import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, withHandlers, withProps, withState } from 'recompose';

import { t } from '../../../../../modules/infra/i18n';
import getInitialValues from './getInitialValues';
import withNotifications from '../../../../common/withNotifications';
import withOwnerTypeAndId from '../../../../common/hoc/withOwnerTypeAndId';
import { getUserUrlPrefix } from '../../../../auth/selectors';
import { createPoVendor } from '../store/actions';
import { canUserModifyProducts } from '../../../../common/helpers/users';

const AddVendorFormContainer = compose(
  withOwnerTypeAndId,
  connect(
    state => ({
      baseUrl: `${getUserUrlPrefix(state)}/products/purchase-orders/vendors`,
      canEditProducts: canUserModifyProducts(state.auth.permissions),
    }), {
      createPoVendor,
    }
  ),
  withRouter,
  withNotifications,
  withState('busy', 'setBusy', false),
  withProps(() => ({
    initialValues: getInitialValues(),
    heading: t('products:vendor_form.add_vendor_heading'),
  })),
  withHandlers({
    submitPoVendor: props => (values) => {
      props.setBusy(true);
      return props.createPoVendor(props.ownerId, values)
        .then(() => {
          props.setBusy(false);
          props.router.push(props.baseUrl);
          props.addNotification({
            title: t('common:success_title'),
            level: 'success',
            message: t('products:vendor_form.vendor_saved_message'),
          });
        })
        .catch(() => {
          props.setBusy(false);
        });
    },
  }),
);

export default AddVendorFormContainer;
